import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { SinglePathSVG } from "components/views/SVG"
import CarrotPropTypes from "../../../../utils/CarrotPropTypes"
import { UserDropdown } from "features/user-dropdown"
import { Box } from "@carrotfertility/carotene-core"

const Hamburger = (props) => (
  <button className="f3 dn-ns pv3 ph35 pa0-ns bn bg-transparent black-80" onClick={props.onClick}>
    <div className="hamburger">
      <div className="hamburger-inner" />
    </div>
  </button>
)

Hamburger.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
}

export const Logo = () => (
  <Link to="/" className="f3 ph4 carrot-orange">
    <SinglePathSVG icon="newLogo" />
  </Link>
)

const LogoBar = (props) => (
  <Box height="80px" alignItems="center" display="flex" justifyContent="space-between" bgcolor="rgb(244, 242, 239)">
    <Hamburger collapsed={props.collapsed} onClick={props.onClick} />
    <Logo />
    <UserDropdown />
  </Box>
)

LogoBar.propTypes = {
  fullName: CarrotPropTypes.userInfo.fullName,
  collapsed: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
}

export default LogoBar
